export default {
  install(Vue, options = {}) {
    Vue.prototype.$print = (el, localOptions, cb = () => true) => {
      let defaultName = "_blank";
      let defaultSpecs = ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"];
      let defaultReplace = true;
      let defaultStyles = [];
      let {
        name = defaultName,
        specs = defaultSpecs,
        replace = defaultReplace,
        styles = defaultStyles
      } = options;

      // If has localOptions
      // TODO: improve logic
      if (localOptions) {
        if (localOptions.name) name = localOptions.name;
        if (localOptions.specs) specs = localOptions.specs;
        if (localOptions.replace) replace = localOptions.replace;
        if (localOptions.styles) styles = localOptions.styles;
      }

      console.warn(styles);

      specs = specs.length ? specs.join(",") : "";

      const element = document.getElementById(el);

      if (!element) {
        alert(`Element to print #${el} not found!`);
        return;
      }

      const url = "";
      const win = window.open(url, name, specs, replace);

      win.document.write(`
        <html>
          <head>
            <link rel="stylesheet" href="./bulma.min.css" type="text/css" />
            <link href="https://fonts.googleapis.com/css?family=Ubuntu+Mono&display=swap" rel="stylesheet">
            <link href="https://fonts.googleapis.com/css2?family=Ubuntu" rel="stylesheet">
            <title>${localOptions.name}</title>
            <style>body{font-family: 'Ubuntu', sans-serif;}.fontMono {font-family: "Ubuntu Mono", monospace;}.margin-top {margin-top: 15px;}</style>
          </head>
          <body>
            ${element.innerHTML}
          </body>
        </html>
      `);

      setTimeout(() => {
        win.document.close();
        win.focus();
        win.print();
        win.close();
        cb();
      }, 1000);

      return true;
    };
  }
};



// WEBPACK FOOTER //
// ./src/helpers/vue-html-to-paper.js